// ===================
// View of a single category
// ===================
PortfolioApp.Views.Category = Backbone.View.extend({
	template: _.template('<a href="#" <% if (active == true){ %>class="active"<% } %>><%= label %></a>'),
	model: PortfolioApp.Models.Category,
	render: function() {
		this.$el.html(this.template(this.model.attributes));
	},
	events: {
		'click a': 'categoryToggle'
	},
	categoryToggle: function(e) {
		e.preventDefault();

		// Find this category object
		var cat = this.model.get('value'),
			catIndex = 0;

		for (var i = 0; i < PortfolioApp.Values.Categories.length; i++) {
			if (PortfolioApp.Values.Categories[i].value == cat) {
				catIndex = i;
				break;
			}
		}

		// Toggle its active state
		PortfolioApp.Values.Categories[catIndex].active = !PortfolioApp.Values.Categories[catIndex].active;
		// Re-render to reflect state!
		this.render();

		PortfolioApp.Values.EntriesView.filterByCategory();
	}
});
